import verConfig, { ver as _ver_ } from '@tt/config'

export const ver = _ver_

const tabbarPages = [
  {
    text: 'newTab.home',
    pagePath: 'goods',
    component: () => import('@/view/goods/homeRedesign'),
    iconPath: require('@/assets/tabbar/new/home.png'),
    selectedIconPath: require('@/assets/tabbar/new/home_active.png'),
    keep: true,
  },
  {
    text: 'homeRedesign.navCart',
    pagePath: 'proRecord',
    component: () => import('@/view/goods/proRecord'),
    iconPath: require('@/assets/tabbar/new/cart.png'),
    selectedIconPath: require('@/assets/tabbar/new/cart_active.png'),
  },
  {
    text: 'homeRedesign.navWallet',
    pagePath: 'Products',
    component: () => import('@/view/wallet'),
    iconPath: require('@/assets/tabbar/new/wallet.png'),
    selectedIconPath: require('@/assets/tabbar/new/wallet_active.png'),
  },
  {
    text: 'newTab.my',
    pagePath: 'user',
    component: () => import('@/view/user'),
    iconPath: require('@/assets/tabbar/new/user.png'),
    selectedIconPath: require('@/assets/tabbar/new/user_active.png'),
  },
]

const redesignedTabbar = {
  type: 'image',
  selectedColor: 'var(--color-primary-strong)',
  pages: tabbarPages,
}

const redesignedTheme = {
  theme: 'var(--color-primary)',
  navBg: '#ffffff',
  navTheme: 'var(--color-text)',
  noticeIconColor: 'var(--color-primary)',
  homeTheme: 'var(--color-primary)',
}

export const verData = {
  T7193: {
    ...verConfig,
    ...redesignedTheme,
    tabbar: redesignedTabbar,
  },
  T7201Test: {
    ...verConfig,
    ...redesignedTheme,
    tabbar: redesignedTabbar,
  },
}

export default verData[ver]
